"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var XIcon16Solid_1 = require("./icons/XIcon/XIcon16Solid");
Object.defineProperty(exports, "XIcon16Solid", { enumerable: true, get: function () { return XIcon16Solid_1.XIcon16Solid; } });
